import { render, staticRenderFns } from "./AffiliationsSelect.vue?vue&type=template&id=057f262d&scoped=true"
import script from "./AffiliationsSelect.vue?vue&type=script&lang=js"
export * from "./AffiliationsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057f262d",
  null
  
)

export default component.exports